import { useState } from 'react'

type Viewport = { width: number; dpr: number }

const readViewport = (): Viewport => ({
  width: (typeof window !== 'undefined' && window.innerWidth) || 1920,
  dpr: (typeof window !== 'undefined' && window.devicePixelRatio) || 1,
})

// Captures viewport width/dpr once on mount (lazy useState initializer). Resize-reactivity
// is intentionally out of scope: images already requested don't resize mid-session, and
// recomputing imageSizes (and re-running every query that reads them) on every resize
// risks a query storm.
const useViewport = (): Viewport => {
  const [viewport] = useState(readViewport)
  return viewport
}

export default useViewport
